<p-toast position="top-center"></p-toast>
<form [formGroup]="bannerForm">
    <main id="main-content" class="grid nested-grid">
        <p-splitter [panelSizes]="[56, 44]" [style]="{'height': '875px'}" class="mb-10">
            <ng-template #panel>
                <div class="col-10 mt-3 px-6">
                    <div class="grid mb-2">
                        <div class="lg:col-8 md:col-10 sm:col-12">
                            <h2 *ngIf="!isUpdateForm">Add Announcement</h2>
                            <h2 *ngIf="isUpdateForm">Modify Announcement</h2>
                        </div>
                    </div>
                    <div class="grid border">
                        <div class="col-12">
                            <div class="grid">
                                <div class="form-group field sm:col-12 md:col-4 lg:col-4">
                                    <label for="bannerType">Announcement Type</label>
                                    <p-select id="bannerType" [options]="bannerTypes" optionLabel="typeName"
                                        optionValue="typeId" formControlName="bannerType"
                                        [style]="{'height':'40px', 'width':'220px'}" placeholder="Select..."></p-select>
                                    <div *ngIf="bannerForm?.get('bannerType')?.invalid && bannerForm?.get('bannerType')?.touched"
                                        class="alert danger-alert error-font">Announcement type is required. </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-12">
                            <div class="grid">
                                <div class="form-group field col-6">
                                    <label for="startDate">Start Date</label>
                                    <p-datepicker id="startDate" appendTo="body" formControlName="startDate" ariaLabelledBy="startDate"
                                        placeholder="mm/dd/yyyy" [iconDisplay]="'input'" [showIcon]="true"
                                        [selectOtherMonths]="true" [readonlyInput]="true" />
                                    <div *ngIf="bannerForm?.get('startDate')?.invalid && bannerForm?.get('startDate')?.touched"
                                        class="alert danger-alert error-font">Start date is required. </div>
                                </div>

                                <div class="form-group field col-6">
                                    <label for="endDate">End Date</label>
                                    <p-datepicker id="endDate" appendTo="body" formControlName="endDate" ariaLabelledBy="endDate"
                                        placeholder="mm/dd/yyyy" [iconDisplay]="'input'" [showIcon]="true"
                                        [selectOtherMonths]="true" [readonlyInput]="true" />
                                    <div *ngIf="bannerForm?.get('endDate')?.invalid && bannerForm?.get('endDate')?.touched"
                                        class="alert danger-alert error-font">End date is required. </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-12">
                            <div class="grid">
                                <div class="form-group field sm:col-12 md:col-4 lg:col-3">
                                    <label for="bannerTitle">Title</label>
                                    <input type="bannerTitle" id="bannerTitle" formControlName="bannerTitle"
                                        [style]="{'height':'40px','width': '435%'}" placeholder="Title" />
                                    <div *ngIf="bannerForm?.get('bannerTitle')?.invalid && bannerForm?.get('bannerTitle')?.touched"
                                        class="alert danger-alert error-font">Title is required.</div>                                        
                                </div>
                            </div>

                        </div>
                        <div class="col-12">
                            <div class="grid">
                                <div class="form-group field sm:col-12 md:col-4 lg:col-3">
                                    <label for="bannerMessage">Message</label>
                                    <textarea rows="15" cols="100" pTextarea placeholder="Enter message here"
                                        id="bannerMessage" formControlName="bannerMessage" [style]="{'width': '435%'}" maxlength="5000"></textarea>
                                    <p class="no-wrap">{{ bannerForm.controls['bannerMessage'].value?.length || 0 }} / 5000 characters</p>                                    
                                    <div *ngIf="bannerForm?.get('bannerMessage')?.invalid  && (bannerForm?.get('bannerMessage')?.dirty ||bannerForm?.get('bannerMessage')?.touched)"
                                        class="alert danger-alert error-font">Message is required. </div>                                         
                                </div>
                            </div>

                        </div>
                        <div class="col-12">
                            <div class="grid">
                                <button type="submit" [ngClass]="{ 'primary default': bannerForm.valid && bannerForm.touched, 'secondary default': bannerForm.invalid || bannerForm.untouched }" (click)="handleSubmit()"
                                    *ngIf="!isUpdateForm" [disabled]="bannerForm.invalid || bannerForm.untouched">Submit</button>
                                <button type="submit" [ngClass]="{ 'primary default': bannerForm.valid && bannerForm.touched, 'secondary default': bannerForm.invalid || bannerForm.untouched }" (click)="handleSubmit()"
                                    *ngIf="isUpdateForm" [disabled]="bannerForm.invalid || bannerForm.untouched ">Update</button>
                                <button class="secondary default" (click)="handleClear()">Clear</button>
                            </div>
                        </div>
                    </div>
                </div>
            </ng-template>
            <ng-template #panel>
                <div>
                    <div class="col-12 mt-3 px-2">
                        <div class="lg:col-12 md:col-12 sm:col-12">
                            <h2>Existing Announcements</h2>
                        </div>
                        <div>
                            <p-table [value]="existingBanners" [paginator]="true" [rows]="10"
                                [tableStyle]="{ 'min-width': '30rem' }" [rowsPerPageOptions]="[5, 10, 20]" [scrollable]="true" scrollHeight="35rem">
                                <ng-template #header>
                                    <tr>
                                        <th style="width:20%">Category</th>
                                        <th style="width:50%">Title</th>
                                        <th style="width:15%">Start Date</th>
                                        <th style="width:15%">End Date</th>
                                        <th style="width:15%">Action</th>
                                    </tr>
                                </ng-template>
                                <ng-template #body let-announcement>
                                    <tr>
                                        <td>{{ announcement.typeName }}</td>
                                        <td>{{ announcement.title }}</td>
                                        <td>{{ announcement.startDate }}</td>
                                        <td>{{ announcement.endDate }}</td>
                                        <td>
                                            <a rel="noopener noreferrer" class="pl-0 p-button p-button-link" (click)="getCurrentAnnouncement(announcement)">Edit</a>
                                            <a rel="noopener noreferrer" class="pl-0 p-button p-button-link" (click)="removeAnnouncement(announcement)">Remove</a>
                                        </td>
                                    </tr>
                                </ng-template>
                            </p-table>
                        </div>
                    </div>
                </div>
            </ng-template>
        </p-splitter>


    </main>

</form>